<template>
  <form :id="widgetType" @submit.prevent="addNewWidget">

    <CommunInputs :widgetConfig="widgetConfig" ></CommunInputs>

    <label for="" class="form-label">Unidad</label>
    <input
      required
      class="form-control"
      v-model="widgetConfig.unit"
      label="Unidad"
      type="text"
      maxlength="4"
    />
    <label for="" class="form-label">Volumen Maximo</label>
    <input required
      class="form-control"
      v-model.number="widgetConfig.maxValue"
      label="Volumen Maximo"
      type="number"
      v-on:input="validateNull(widgetConfig)"
    />

    <label for="" class="form-label">Cantidad de Decimales</label>
    <input required
      class="form-control"
      v-model.number="widgetConfig.decimalPlaces"
      label="Cantidad de decimales"
      type="number"
      v-on:input="validateCount(widgetConfig)"
    />
    <label for="" class="form-label">Icono</label>
    <IconsForm :value="widgetConfig"></IconsForm>

    <label for="" class="form-label">Seleccionar Color</label>
    <select
      v-model="widgetConfig.class"
      class="form-select"
      placeholder="Seleccionar Color"
      style="width: 100%"
    >
      <option class="text-success" value="success" label="Verde"></option>
      <option class="text-primary" value="primary" label="Azul"></option>
      <option class="text-warning" value="warning" label="Amarillo"></option>
      <option class="text-danger" value="danger" label="Rojo"></option>
    </select>

  </form>
</template>

<script>
import IconsForm from './IconsForm.vue';
import CommunInputs from './common/CommunInputs.vue';
export default {
  props: ["widgetConfig", "addNewWidget", "validateCount", "widgetType"],
  components:{
    IconsForm,
    CommunInputs
  },
  methods:{
    validateNull(widget){
      if (widget.maxValue == "") {
        widget.maxValue = 100
      }
    },

  }
};
</script>
